import { AxiosRequestConfig } from 'axios';

import { urlParser } from '@hh.ru/browser-api-utils';

const defaultHeadersInterceptor = (config: AxiosRequestConfig): AxiosRequestConfig => {
    if (!config.url) {
        return config;
    }

    const parsedUrl = urlParser(config.url);

    if (!parsedUrl.hostname || parsedUrl.hostname === window.location.hostname) {
        config.headers = config.headers ?? {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
    }
    return config;
};

export default defaultHeadersInterceptor;
